import {
  MT5_DEPOSIT_WIDTHDRAW,
  MT5_DEPOSIT_WIDTHDRAW_SUCCESS,
  MT5_DEPOSIT_WIDTHDRAW_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  mt5Data: {},
};

const mt5DepositWidthdrawReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case MT5_DEPOSIT_WIDTHDRAW:
      return { ...state, loading: true };
    case MT5_DEPOSIT_WIDTHDRAW_SUCCESS:
      return {
        ...state,
        mt5Data: action?.payload,
        loading: false,
      };
    case MT5_DEPOSIT_WIDTHDRAW_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default mt5DepositWidthdrawReducer;
